import { render, staticRenderFns } from "./NoJdcDeadlinesHandler.vue?vue&type=template&id=0ff20bcd&scoped=true"
import script from "./NoJdcDeadlinesHandler.vue?vue&type=script&lang=js"
export * from "./NoJdcDeadlinesHandler.vue?vue&type=script&lang=js"
import style0 from "./NoJdcDeadlinesHandler.vue?vue&type=style&index=0&id=0ff20bcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff20bcd",
  null
  
)

export default component.exports